<template>
  <main class="quote-page">
    <section class="quote-hero" aria-labelledby="quote-title">
      <div class="d-flex mb-4">
        <router-link to="/" class="back-link">
          <i class="fa-solid fa-arrow-left"></i>
        Volver al inicio
      </router-link>
      <span class="section-kicker">Cotizacion</span>
    </div>
      <h1 id="quote-title">Solicita una cotizacion para el producto que necesitas.</h1>
      <p>
        Selecciona un producto, comparte tus datos y nuestro equipo te contactara para
        revisar disponibilidad, detalles y siguientes pasos.
      </p>
    </section>

    <section class="quote-form-section" aria-label="Formulario de cotizacion">
      <p v-if="productsError" class="quote-alert">
        {{ productsError }}
      </p>
      <DemoLeadForm
        mode="inline"
        :endpoint="leadsEndpoint"
        :product-id="selectedProductId"
        :show-product-select="true"
        :product-options="products"
        :products-loading="productsLoading"
        fuente="cotizacion"
        initial-message="Quiero solicitar una cotizacion"
      />
    </section>
  </main>
</template>

<script>
import DemoLeadForm from './DemoLeadForm.vue'

const buildDemoEndpoint = (path) => {
  const baseUrl = process.env.VUE_APP_DEMO_LEADS_ENDPOINT || 'http://localhost:8082'

  return `${baseUrl.replace(/\/$/, '')}/${path.replace(/^\//, '')}`
}

export default {
  name: 'CotizacionApp',
  components: {
    DemoLeadForm,
  },
  data() {
    return {
      products: [],
      productsLoading: false,
      productsError: '',
      selectedProductId: '',
      leadsEndpoint: buildDemoEndpoint('leads'),
      productsEndpoint: buildDemoEndpoint('products'),
      tenant: 'axum',
    }
  },
  beforeMount() {
    this.selectedProductId = this.getProductIdFromRoute()
    this.getProducts()
  },
  watch: {
    $route() {
      this.selectedProductId = this.getProductIdFromRoute()
    },
  },
  methods: {
    getProductIdFromRoute() {
      const productId = this.$route.params.productId || this.$route.query.product_id || this.$route.query.productId || ''
      const numericProductId = Number(productId)

      return productId && !Number.isNaN(numericProductId) ? numericProductId : productId
    },
    normalizeProducts(data) {
      const list = Array.isArray(data)
        ? data
        : data.results || data.products || (data.data && data.data.products) || []

      return list
        .map((product) => ({
          id: product.id,
          name: product.name || product.nombre || product.title || `Producto ${product.id}`,
        }))
        .filter((product) => product.id !== undefined && product.id !== null)
    },
    async getProducts() {
      this.productsLoading = true
      this.productsError = ''

      try {
        const response = await fetch(this.productsEndpoint, {
          method: 'GET',
          headers: {
            'X-Tenant': this.tenant,
          },
          redirect: 'follow',
        })

        if (!response.ok) {
          throw new Error(`No se pudieron cargar los productos (${response.status})`)
        }

        const data = await response.json()
        this.products = this.normalizeProducts(data)
      } catch (error) {
        this.productsError = error.message || 'No se pudieron cargar los productos.'
      } finally {
        this.productsLoading = false
      }
    },
  },
}
</script>

<style scoped>
.quote-page {
  color-scheme: light;
  --charcoal: #434341;
  --sand: #f4ba56;
  --silver: #dbdbdb;
  --white: #ffffff;
  --oxford: #14213d;
  --blue: #0a3d91;
  --soft-bg: #f7f7f8;
  color: var(--charcoal);
  font-family: "Montserrat", sans-serif;
}

.quote-page :where(h1, h2, p, a, span) {
  font-family: "Montserrat", sans-serif;
}

.quote-hero,
.quote-form-section {
  max-width: 980px;
  margin: 0 auto;
  padding-inline: 28px;
}

.quote-hero {
  padding-block: 72px 36px;
}

.back-link,
.section-kicker {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  font-weight: 800;
  text-decoration: none;
}

.back-link {
  gap: 8px;
  margin-right: 16px;
  
  /* margin-bottom: 34px; */
  color: var(--oxford);
  font-size: 0.86rem;
}

.section-kicker {
  color: var(--blue);
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.section-kicker::before {
  content: "";
  width: 28px;
  height: 2px;
  margin-right: 10px;
  background-color: var(--sand);
}

.quote-hero h1 {
  max-width: 820px;
  margin: 14px 0 0;
  color: var(--oxford);
  font-size: clamp(2.15rem, 4.2vw, 3.8rem);
  font-weight: 600;
  line-height: 1.02;
}

.quote-hero p {
  max-width: 720px;
  margin: 22px 0 0;
  color: #5b5b57;
  font-size: 1rem;
  line-height: 1.82;
}

.quote-form-section {
  margin-bottom: 64px;
}

.quote-alert {
  margin: 0 0 16px;
  padding: 12px 14px;
  color: #991b1b;
  border-radius: 8px;
  background-color: #fee2e2;
  font-weight: 800;
}

@media (max-width: 640px) {
  .quote-hero,
  .quote-form-section {
    padding-inline: 18px;
  }

  .quote-hero {
    padding-block: 54px 28px;
  }

  .quote-hero h1 {
    font-size: clamp(2rem, 10vw, 2.8rem);
  }
}
</style>
